import { Routes, Route } from 'react-router';
import { Layout } from './components/layout/Layout.jsx';
import { ScrollToTop } from './components/layout/ScrollToTop.jsx';
import { DocumentMeta } from './components/layout/DocumentMeta.jsx';
import HomePage from './pages/HomePage.jsx';
import ProcessPage from './pages/ProcessPage.jsx';
import ProjectsPage from './pages/ProjectsPage.jsx';
import ProjectDetailPage from './pages/ProjectDetailPage.jsx';
import AboutPage from './pages/AboutPage.jsx';
import ContactPage from './pages/ContactPage.jsx';
import NotFoundPage from './pages/NotFoundPage.jsx';

export default function App() {
  return (
    <>
      <ScrollToTop />
      <DocumentMeta />
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="process" element={<ProcessPage />} />
          <Route path="projects" element={<ProjectsPage />} />
          <Route path="projects/:slug" element={<ProjectDetailPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </>
  );
}
